import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0003',
    ecrans: ['00-2'],
    params: ['?doccleint']
});
